import { render, staticRenderFns } from "./SalesList.vue?vue&type=template&id=46ae9956"
import script from "./SalesList.vue?vue&type=script&lang=js"
export * from "./SalesList.vue?vue&type=script&lang=js"
import style0 from "./SalesList.vue?vue&type=style&index=0&id=46ae9956&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports